'use strict';

import angular from 'angular';
import ShowController from './show.controller';

export default angular.module('logServerApp.main.show', [])
  .controller('ReportShowController', ShowController)
  .name;



// WEBPACK FOOTER //
// ./client/app/main/show/index.js